import axios from 'axios';

const instance = axios.create({
	baseURL: 'https://sreelakshmiheavenshostels.co.in/api'
});
export default instance;